// DON'T CHANGE THESE BECAUSE THEY ARE SAVED. ONLY ADD ITEMS.
export enum CaptionsDisplayMode {
  AllVisible,
  Pages,
  ComposeAll,
  ComposePages
}

export const CAPTIONS_DISPLAY_MODE_LABELS: string[] = [
  'All visible',
  'Pages',
  'Compose all',
  'Compose pages'
];



// WEBPACK FOOTER //
// ./src/captions/CaptionsDisplayMode.ts